import { css } from '@emotion/css'
import appSettings from '../../app/app-settings'

const photoViewCss = {
  photoCornerWrapper: () => css({
    display: "grid",
    gridTemplateColumns: "1fr 3fr",
    alignItems: "center",

    [appSettings.mediaQueries.largeDesktop]: {
      gap: 60,
    },

    [appSettings.mediaQueries.desktop]: {
      gap: 60,
    },

    [appSettings.mediaQueries.largeTablet]: {
      gap: 40,
    },

    [appSettings.mediaQueries.smallTablet]: {
      gridTemplateColumns: "1fr",
      gap: 30,
    },
  }),

  photoCorner: () => css({
    height: 250,
    justifySelf: "center",
  }),

  paragraph: () => css({
    textAlign: "center",
    marginBottom: 20,
  }),

  iframePhotos: () => css({
    width: "100%",
    height: 600,
    justifySelf: "center",
    border: "none"
  }),

  videoWrapper: () => css({
    display: "flex",
    justifyContent: "center",
  }),
}

export default photoViewCss
